(() => {
  angular
    .module('app.settings')
    .controller('FreewheelModalController', FreewheelModal);

  FreewheelModal.$inject = [
    'close',
    'provider',
    'CountriesList',
    'allowedMetrics',
    'allowedCountries',
  ];

  function FreewheelModal(
    close,
    provider,
    CountriesList,
    allowedMetrics,
    allowedCountries,
  ) {
    const vm = this;

    /* ************************************************************* */
    /* **************************** Tabs *************************** */
    /* ************************************************************* */
    const tabAction = {};

    vm.tabs = [{
      id: 'credentials',
      label: 'Credentials',
    }, {
      id: 'integration',
      label: 'Integration',
    }, {
      id: 'country',
      label: 'Country',
    }, {
      id: 'quality',
      label: 'Quality',
    }, {
      id: 'complete',
      label: 'Complete',
    }];

    vm.tabActive = 'credentials'; // -1;
    vm.isTabActive = id => id === vm.tabActive;
    vm.onTabSelect = id => {
      vm.tabActive = id;
      vm.tabs = vm.tabs.map(item => item.id === id ? { ...item, enable: true } : item);

      if (tabAction[id]) {
        tabAction[id]();
      }
    };

    vm.hasTabError = id => {
      const tab = vm.tabs.find(item => item.id === id);
      if (tab.done && id === 'credentials' && vm.credentialsError) {
        return true;
      }

      return false;
    };



    /* ************************************************************* */
    /* ************************** Start **************************** */
    /* ************************************************************* */
    vm.username = ''; // 'audience_project@dnitest';
    vm.password = ''; // 'Discovery20!';

    vm.name = '';
    vm.trackingCode = $('#current-user').data('cid');
    vm.integrationCode = '';

    vm.onStart = () => vm.tabActive = 'credentials';

    provider.integrations({});



    /* ************************************************************* */
    /* *************************** Country ************************* */
    /* ************************************************************* */
    vm.countries = CountriesList.filter(item => allowedCountries.includes(item.code));
    vm.onSelectCountry = country => vm.selectedCountry = country;

    const country = ''; // FIXME: get integration country
    vm.selectedCountry = vm.countries.find(item => item.code === (country || 'DK'));



    /* ************************************************************* */
    /* *************************** Quality ************************* */
    /* ************************************************************* */
    vm.metrics = allowedMetrics.reduce((memo, { key, name }) => ([...memo, { key, name }]), []);
    vm.onCheckMetric = metric => {
      const activeMetric = vm.metrics.find(item => item.name === metric.name);
      activeMetric.checked = !activeMetric.checked;
    };



    /* ************************************************************* */
    /* *************************** Actions ************************* */
    /* ************************************************************* */
    vm.onClose = () => close(false, 0);
    vm.onCloseWithReload = () => close(true, 0);

    vm.onBack = id => vm.onTabSelect(id);
    vm.onNext = id => {
      vm.tabs = vm.tabs.map(item => (
        item.id === vm.tabActive ? {
          ...item,
          enable: true,
          done: true,
        } : item
      ));
      vm.onTabSelect(id);

      if (tabAction[id]) {
        tabAction[id]();
      }
    };

    vm.onCreate = () => {
      const credentilas = {
        username: vm.username,
        password: vm.password,
        trackingCode: vm.trackingCode,
        integrationCode: vm.integrationCode || null,
      };

      const integration = {
        name: vm.name,
        country: vm.selectedCountry.code,
        trackingCode: vm.trackingCode,
        qualityMetrics: vm.metrics.filter(item => item.checked).map(item => item.key),
        integrationCode: vm.integrationCode || null,
      };

      vm.isProcessBusy = true;

      provider.credentials(credentilas)
        .then(() => {
          provider.create(integration);
          vm.credentialsError = '';
          vm.onNext('complete');
        })
        .catch(error => {
          if (error.status === 400) {
            vm.credentialsError = error.data.errorMessage;
            console.error(error.data.errorMessage);
          }
        }).finally(() => {
          vm.isProcessBusy = false;
        });
    };
  }
})();
